import { Injectable } from '@angular/core';

import { LandlineNumber } from '../interfaces/landline-number.interface';

@Injectable({
    providedIn: 'root',
})
export class LandlineNumberService {
    private readonly RIO_LIST: LandlineNumber[] = [
        {
            provider: 'ACN Communications',
            phoneNumber: '0800713179',
        },
        {
            provider: 'Afone',
            phoneNumber: '0805163179',
        },
        {
            provider: 'Akeo Telecom',
            phoneNumber: '0800713179',
        },
        {
            provider: 'Budget Telecom',
            phoneNumber: '0800713179',
        },
        {
            provider: 'Ciel Telecom',
            phoneNumber: '0800713179',
        },
        {
            provider: 'Coriolis',
            phoneNumber: '0800713179',
        },
        {
            provider: 'France Telephony',
            phoneNumber: '0800713179',
        },
        {
            provider: 'Free',
            phoneNumber: '0805923179',
        },
        {
            provider: 'IP Directions',
            phoneNumber: '0805283179',
        },
        {
            provider: 'Legos',
            phoneNumber: '0805084198',
        },
        {
            provider: 'Numericable',
            phoneNumber: '0805858985',
        },
        {
            provider: 'Orange',
            phoneNumber: '0800003179',
        },
        {
            provider: 'OVH',
            phoneNumber: '0805693179',
        },
        {
            provider: 'Prixtel',
            phoneNumber: '0800713179',
        },
        {
            provider: 'Réseau Santé Social',
            phoneNumber: '0800713179',
        },
        {
            provider: 'SFR',
            phoneNumber: '0800973179',
        },
        {
            provider: 'Sosh',
            phoneNumber: '0800003179',
        },
        {
            provider: 'UKtelecom',
            phoneNumber: '0800713179',
        },
        {
            provider: 'Virgin',
            phoneNumber: '0800713179',
        },
    ];

    public getRIOList(): LandlineNumber[] {
        return this.RIO_LIST.sort((a, b) => a.provider.localeCompare(b.provider));
    }
}
